const howItWorksStyles = {
    container: {
        backgroundColor: "#FFFFFF",
        px: { xs: "20px", sm: "30px", md: "40px", lg: "79.09px" },
        pt: { xs: "33.06px", sm: "30px", md: "40px", lg: "29.04px" },
        pb: { xs: "33.06px", sm: "30px", md: "40px", lg: "70px" },
    },
    headerContainer: {
        textAlign: { xs: "left", sm: "center" },
    },
    headerText: {
        fontSize: { xs: "24px", sm: "32px", md: "40px" },
        fontWeight: "400",
        lineHeight: { xs: "24px", sm: "36px", md: "48px" },
        color: "#0F0F0F",
        fontFamily: "Belleza",
    },
    headerLine: {
        mx: { xs: "0", sm: "auto" },
        width: { xs: "67.18px" },
        height: { xs: "1px" },
        backgroundColor: "#0F0F0F",
        mt: { xs: "11.02px", sm: "16.03px" },
        mb: { xs: "15.97px", sm: "35.22px" },
    },
    stepContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: { xs: "flex-start", md: "center" },
    },
    stepNumber: {
        fontSize: { xs: "14px", sm: "15px", md: "16px" },
        fontWeight: "700",
        lineHeight: { xs: "16px", sm: "18px", md: "20px" },
        color: { xs: "#808080", sm: "#0F0F0F" },
        fontFamily: "Lexend",
        mb: { xs: "5px", sm: "7px" },
    },
    stepTitle: {
        fontSize: { xs: "11px", sm: "18px", md: "21px" },
        fontWeight: "600",
        lineHeight: { xs: "24px", sm: "21.6px", md: "25px" },
        color: "#0F0F0F",
        fontFamily: "Lexend",
        mb: { xs: "4px", sm: "5px" },
    },
    stepDescription: {
        fontSize: { xs: "11px", sm: "15px", md: "16px" },
        fontWeight: "300",
        lineHeight: { xs: "16px", sm: "18px", md: "22px" },
        color: "#0F0F0F",
        fontFamily: "Lexend",
    },
}

export default howItWorksStyles;